import { render, staticRenderFns } from "./kids.vue?vue&type=template&id=5c282708"
import script from "./kids.vue?vue&type=script&lang=js"
export * from "./kids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports